<template>
  <div class="account-tab-content tab-overview">
    <TableAccount
      :title="'Transaction(s) Overview'"
      :fields="fields"
      :items="transactions"
      :current-page="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      @changePage="handleChangePage"
    />
  </div>
</template>

<script>
import TableAccount from '@/components/common/table/table';
import accountService from '@/services/account.service';

export default {
  components: {
    TableAccount
  },
  data() {
    return {
      transactions: [],
      total: 0,
      perPage: 3,
      currentPage: 1,
      fields: [
        {key: 'id', label: 'Transaction ID'},
        {key: 'date', label: 'Date'},
        {key: 'type', label: 'Type'},
        {key: 'mainNumbers', label: 'Your Numbers'},
        {key: 'wager', label: 'Amount'},
        {key: 'winnings', label: 'Winnings'},
        {key: 'action', label: '', actions: [
            {
              'title': 'QR CODE',
              'action': 'handleReplayQrCodeTicket',
              'value': 'id'
            }
          ]}
      ]
    }
  },
  computed: {
    rows() {
      return this.total
    }
  },
  created() {
    accountService.transactions(this.currentPage).then((res) => {
      if (res) {
        for(const tId in res.transactions) {
          res.transactions[tId].forEach((bet, i) => {
            this.transactions.push(bet);
          })
        }

        this.total = res.total;
      }
    });
  },
  methods: {
    handleChangePage(val) {
      this.currentPage = val;
      accountService.transactions(this.currentPage).then((res) => {
        if (res) {
          this.transactions = res.transactions;
        }
      });
    }
  }
}
</script>
